import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class SegmentedButton extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            selected: props.defaultSelected || (props.options.length > 0 ? props.options[0].value : null),
        };
    }

    handleSelection = (value) => {
        this.setState({ selected: value });
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    };

    render() {
        const { options, className } = this.props;
        const { selected } = this.state;

        return (
            <div className={classNames('segmented-button', className)}>
                {options.map(({ value, label, icon }) => (
                    <button
                        key={value}
                        className={classNames('segmented-button__option', {
                            'segmented-button__option--selected': selected === value,
                        })}
                        onClick={() => this.handleSelection(value)}
                    >
                        {icon && <i className="material-icons">{icon}</i>}
                        {label}
                    </button>
                ))}
            </div>
        );
    }
}

SegmentedButton.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.string,
        })
    ).isRequired,
    defaultSelected: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

SegmentedButton.defaultProps = {
    defaultSelected: null,
    onChange: null,
    className: '',
};

export default SegmentedButton;
